export default __webpack_public_path__ + "static/media/Icons-37.f4a46d69.png";